import { RouteRecordRaw } from "vue-router"

// ====================================
// Module IRVE
// ====================================
// Route simulation IRVE (fiche bâtiment) : @core/router/building.routes.ts

export const routes = [] as RouteRecordRaw[]
